<template>
    <div>User is being authenticated</div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'Oidc-Callback',
    methods: {
        ...mapActions('oidcStore', ['oidcSignInCallback'])
    },
    created() {
        //let route = this.$route;
        this.oidcSignInCallback()
            .then(redirectPath => this.$router.push(redirectPath))
            .catch(err => {
                window.console.log("oidc-err", err.message);
                this.$router.push('/auth-error')
            });
    }
}
</script>